import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-infringement-type',
    templateUrl: './infringement-type.component.html',
    styleUrls: ['./infringement-type.component.scss'],
    standalone: false
})
export class InfringementTypeComponent extends ModelEditor {

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super('enforcement/infringement-types', injector);
  }

  public DefaultModel() {
    return {
      Name: '',
      Description: '',
      BaseFine: 0,
      IsActive: true,
      AppealEligible: true,
      Escalations: []
    };
  }

  public AfterModelLoaded(): void {
  }

  public BeforeSave(): boolean | void {
  }

  public Validators() {
    return {};
  }
}


